import styled from "styled-components";
import {ScreenScrapeStepTitle} from "./common/ScreenScrapeStepTitle";

const Text = styled.p`
  text-align: center;
  margin-bottom: 0.5rem;
`;

const Container = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const TransactionsConfirmationPopup = () => {

    return (
        <>
            <ScreenScrapeStepTitle>Wymagana zgoda na pobranie transakcji</ScreenScrapeStepTitle>
            <Container>
                <Text>
                    Potwierdź w aplikacji mobilnej
                </Text>
            </Container>
        </>
    );
};